import { createSelector } from 'reselect';
import { getDocumentsById } from 'documents/store/documents/selectors';

export const getIsOffline = (state) => state.offline.isOffline;

export const getCurrentlyCachingOfflineDocuments = (state) =>
  state.offline.currentlyCachingDocuments;

export const getCurrentlyCachingOfflineDocumentIdsWithIncorrectPassword = (state) =>
  state.offline.currentlyCachingDocumentIdsWithIncorrectPassword;

export const getOfflineDocumentIds = (state) => state.offline.ids;

export const getOfflineSyncErrorIds = (state) => state.offline.syncErrorIds;

export const getOfflineStorageErrorIds = (state) => state.offline.storageErrorIds;

export const getOfflineWaitingForSyncIds = (state) => state.offline.waitingForSyncIds;

export const getOfflineIsSyncing = (state) => state.offline.isSyncing;

export const getOfflineDocuments = createSelector(
  [
    getDocumentsById,
    getOfflineDocumentIds,
    getOfflineWaitingForSyncIds,
    getOfflineSyncErrorIds,
    getOfflineStorageErrorIds,
  ],
  (documents, ids, waitingForSyncIds, syncErrorIds, storageErrorIds) =>
    ids.map((id) => {
      const status = ((id) => {
        if (syncErrorIds.includes(id)) {
          return 'Sync error';
        } if (storageErrorIds.includes(id)) {
          return 'Storage error';
        } if (waitingForSyncIds.includes(id)) {
          return 'Offline changes';
        }
        return 'Up to date';
      })(id);

      return {
        ...documents[id],
        status,
      };
    }) || [],
);
